import { defineMessages } from 'react-intl';

export const messages: {
	errorPrimary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorSecondary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorPrimary: {
		id: 'error_primary',
		defaultMessage: "We're having trouble searching",
		description: 'Message shown when search request fails',
	},
	errorSecondary: {
		id: 'error_secondary',
		defaultMessage: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
		description: 'Additional message to prompt users to try again',
	},
});
